/**
 * UserSettingsEvents
 * Registry of events for UserSettings pages + components (profile + preferences)
 */
export enum UserSettingsEvents {
    NewProfileSubmitSuccess = "Users - New Profile - Submit Success",
    NewProfileSubmitError = "Users - New Profile - Submit Error",
    // // // //
    // Profile Page
    UpdateOccupationSuccess = "Users - Profile Page - Update Occupation Success",
    UpdateOccupationError = "Users - Profile Page - Update Occupation Error",
    UpdateAcquisitionChannelSuccess = "Users - Profile Page - Update AcquisitionChannel Success",
    UpdateAcquisitionChannelError = "Users - Profile Page - Update AcquisitionChannel Error",
    UpdateAssetClassInterestSuccess = "Users - Profile Page - Update AssetClassInterest Success",
    UpdateAssetClassInterestError = "Users - Profile Page - Update AssetClassInterest Error",
    UpdateShouldReceiveMarketingSuccess = "Users - Profile Page - Update ShouldReceiveMarketing Success",
    UpdateShouldReceiveMarketingError = "Users - Profile Page - Update ShouldReceiveMarketing Error",
}
